export const Topic = {
    "话题标题":"Title",
    "导入已有话题":"Import existing",
    "话题详情":"Topic details",
    "添加话题讨论":"Add discussion",
    "请输入留言":"Please enter a message",
    "发表":"Publish",
   
    
}